interface MaintenanceConfig {
  messageOverride?: string;
  expectedEndTime?: string;
  contactEmail?: string;
}

export const isMaintenanceMode = (): boolean => {
  console.log('Checking maintenance mode...');

  // Check environment variable first
  const envMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  console.log('Environment maintenance mode:', envMaintenanceMode);

  // Check localStorage for override (useful for testing)
  const localStorageMaintenanceMode =
    localStorage.getItem('maintenanceMode') === 'true';
  console.log('LocalStorage maintenance mode:', localStorageMaintenanceMode);

  const isEnabled = envMaintenanceMode || localStorageMaintenanceMode;
  console.log('Final maintenance mode result:', isEnabled);

  return isEnabled;
};

export const enableMaintenanceMode = (): void => {
  localStorage.setItem('maintenanceMode', 'true');
  console.log('Maintenance mode enabled via localStorage');
};

export const disableMaintenanceMode = (): void => {
  localStorage.removeItem('maintenanceMode');
  console.log('Maintenance mode disabled via localStorage');
};

export const getMaintenanceConfig = (): MaintenanceConfig => {
  const config: MaintenanceConfig = {};

  // Check for custom message override
  const messageOverride =
    process.env.REACT_APP_MAINTENANCE_MESSAGE ||
    localStorage.getItem('maintenanceMessage');
  if (messageOverride) {
    config.messageOverride = messageOverride;
  }

  // Check for expected end time
  const expectedEndTime =
    process.env.REACT_APP_MAINTENANCE_END_TIME ||
    localStorage.getItem('maintenanceEndTime');
  if (expectedEndTime) {
    config.expectedEndTime = expectedEndTime;
  }

  // Check for contact email
  const contactEmail =
    process.env.REACT_APP_MAINTENANCE_CONTACT ||
    localStorage.getItem('maintenanceContact');
  if (contactEmail) {
    config.contactEmail = contactEmail;
  }

  console.log('Maintenance config:', config);
  return config;
};
